export const TEST_ID = 'phWarningsSection';

export const PH_DECIMAL_PRECISION = 1;
